|<template>
	<div id="login">
		<div class="container-fluid">
			<div class="row main-content bg-success text-center">
				<div class="col-md-4 text-center company__info">
					<span class="company__logo"><img src="/img/aces-chile-logo.png"></span>
					<div class="text-center" v-if="'development' == getEnvironment">
						<span @dblclick="changeEnvironment" class="pointer">{{ getEnvironmentCurrent | capitalize }}</span>
					</div>
				</div>
				<div class="col-md-8 col-xs-12 col-sm-12 login_form " >
					<div class="row">
						<div class="col-12 text-aces text-center">
						<br>
							<span class="company__logo_2"><img src="/img/aces-chile-logo.png" width="100px"></span>
							<br>
							<h4>Control de Acceso</h4>
						</div>
						<div class="col-12 text-center">
							<form control="text-aces" class="form-group form_">
								<div class="row">
									<input type="text" name="username" id="username" class="form__input" placeholder="Correo Electronico" v-model="data.email">
								</div>
								<div class="row">
									<!-- <span class="fa fa-lock"></span> -->
									<input type="password" name="password" id="password" class="form__input" placeholder="Contraseña" v-model="data.password">
								</div>
								<div class="col-12 text-center">
									<input type="submit" value="Ingresar" class=" btn btn_" @click="connect" :disabled="disableBtnConection">
								</div>
							</form>
						</div>
						<div class="row" v-show="1==2">
							<p>Don't have an account? <a href="#">Register Here</a></p>
						</div>
					</div>
				</div>
			</div>
			<div class="container-fluid error-login" v-if="error == 1">
				<div class="alert alert-warning alert-dismissible fade show" role="alert">
					<strong>Error!!!</strong> Datos incorrectos
					<button type="button" class="close" aria-label="Close" @click="closeError">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
			<div class="container-fluid error-login" v-if="error == 2">
				<div class="alert alert-danger alert-dismissible fade show" role="alert">
					<strong>Error!!!</strong> Problema de Red, no se pudo establecer conexión
					<button type="button" class="close" aria-label="Close"  @click="closeError">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'

export default {
	name: 'Login',
	mixins: [mixin],
	data() {
		return {
			data: {
				email: '',
				password: ''
			},
			disableBtnConection: false,
			error: 0,
		}
	},
	components: {
	},
	computed: {
	},
	methods: {
		initLayoutLocal() {
			localStorage.removeItem('token');
		},
		closeError() {
			this.error = 0
		},
		connect() {
			if(!this.disableBtnConection) {
				this.disableBtnConection = true
				console.log(this.getApiBackend + 'login')
				this.axios
						.post(this.getApiBackend + 'login', this.data)
						.then(response => {
							if(response.data.success) {
								console.log("Conectado!!!")
								localStorage.token = response.data.data.token
								setTimeout(()=>{ this.disableBtnConection = false; this.$router.push('/'); }, 1000);
							} else {
								console.error("iSystem4: Error - Datos invalidos")
								this.error = 1
								this.disableBtnConection = false
							}
						})
						.catch(response => {
							console.error('iSystem4: ERROR - Problema de Red, no se pudo establecer conexión')
							this.error = 2
							this.disableBtnConection = false
							this.errorHttpHandling(error)
						})
			}
		}
	},
	mounted () {
		this.initLayout()
	}
}	
</script>

<style lang="scss">
@import 'assets/loginv6/vendor/bootstrap/css/bootstrap.min.css';
@import 'assets/loginv6/vendor/animate/animate.css';
@import 'assets/loginv6/vendor/css-hamburgers/hamburgers.min.css';
@import 'assets/loginv6/vendor/animsition/css/animsition.min.css';
@import 'assets/loginv6/vendor/select2/select2.min.css';
@import 'assets/loginv6/vendor/daterangepicker/daterangepicker.css';
@import 'assets/loginv6/css/main.css';
@import 'assets/loginv6/css/util.css';

.main-content{
	width: 50%;
	border-radius: 20px;
	box-shadow: 0 5px 5px rgba(0,0,0,.4);
	margin: 5em auto;
	display: flex;
	background: url(https://images.unsplash.com/photo-1507208773393-40d9fc670acf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80) no-repeat center;
	background-size: cover;
}

.error-login{width: 50%;}

.company__info{
	border-top-left-radius: 20px;
	border-bottom-left-radius: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #fff;
	background: rgba(80, 180, 187, .8)
}
.fa-android{
	font-size:3em;
}

.company__logo_2 {
	display: none;
}
@media screen and (max-width: 640px) {
	.main-content{width: 90%;}
	.error-login{width: 95%;}
	.company__info{
		display: none;
	}
	.company__logo_2 {display: block;}
	.login_form{
		border-top-left-radius:20px;
		border-bottom-left-radius:20px;
	}
}
@media screen and (min-width: 642px) and (max-width:800px){
	.main-content{width: 70%;}
}
.row_ > h2_{
	color:#008080;
}
.login_form{
	background-color: #fff;
	border-top-right-radius:20px;
	border-bottom-right-radius:20px;
	border-top:1px solid #ccc;
	border-right:1px solid #ccc;
}
.form_{
	padding: 0 2em;
}
.form__input{
	width: 100%;
	border:0px solid transparent;
	border-radius: 0;
	border-bottom: 1px solid #aaa;
	padding: 1em .5em .5em;
	padding-left: 2em;
	outline:none;
	margin:1.5em auto;
	transition: all .5s ease;
}
.form__input:focus{
	border-bottom-color: #008080;
	box-shadow: 0 0 5px rgba(151,140,135,.4); 
	border-radius: 4px;
}
.btn_{
	transition: all .5s ease;
	width: 70%;
	border-radius: 30px;
	color:#008080;
	font-weight: 600;
	background-color: #fff;
	border: 1px solid #008080;
	margin-top: 1.5em;
	margin-bottom: 1em;
}
.btn_:hover, .btn_:focus{
	background-color: #00b7bd;
	color:#fff;
}

.text-aces {
    color: #50b4bb;
}
</style>
